import React, { Component } from 'react'
import { bool, func } from 'prop-types'
import Modal from 'react-modal'
import { translate } from 'react-i18next'
import AvatarEditor from 'react-avatar-editor'
import config from '../../config'
import { stores } from '../../stores'
import { blobToFile, dataURItoBlob, readFile } from '../../utilities/blob'

class ModalAvatar extends Component {
  constructor () {
    super()

    this.state = {
      reason: '',
      files: {},
      scale: 1,
      image: '',
      imagePath: config.profile_image_default
    }
  }

  /*
   * Handler for the scale input
   */
  handleScale (e) {
    const scale = parseFloat(e.target.value)
    this.setState({ scale })
  }

  _handleImageChange (e) {
    e.preventDefault()
    readFile({ file: e.target.files[0] })((file, result) => {
      this.setState({
        image: file,
        imagePath: result
      })
    })
  }

  /*
   * Submit the modified image to the server
   */
  async handleSubmit () {
    const canvas = this.editor.getImageScaledToCanvas()
    // Create the image file
    let dataUrl = canvas.toDataURL('image/png')
    let blob = dataURItoBlob(dataUrl)
    const picture = blobToFile(blob, 'profile.png')
    await stores.account.updatePicture({ picture })
    this.props.handleClose()
  }

  setEditorRef (editor) {
    this.editor = editor
  }

  render () {
    const { t } = this.props
    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={() => this.props.handleClose()}
        contentLabel='Minimal Modal Example'
        className='modal modal--auto'
        overlayClassName='signup_overlay'
        >
        <span onClick={() => this.props.handleClose()} style={{cursor: 'pointer'}} className='ReactModal__close'><img src='/app/images/close.png' alt='' /></span>
        <p>{t('common:account:profile_upload_message')}</p>
        <input onChange={(e) => this._handleImageChange(e)} ref='image' type='file' accept='image/*' />
        <div style={{width: '350px', margin: '0 auto'}}>
          <AvatarEditor
            ref={(ref) => this.setEditorRef(ref)}
            image={this.state.imagePath}
            width={250}
            height={250}
            border={50}
            scale={this.state.scale}
            />
        </div>
        <div>
            Zoom:
            <input
              name='scale'
              type='range'
              onChange={(e) => this.handleScale(e)}
              min='1'
              max='2'
              step='0.05'
              defaultValue='1'
              style={{ marginTop: '0', marginBottom: '0', marginRight: 'auto', marginLeft: 'auto' }}
            />
        </div>

        <button style={{clear: 'both'}} onClick={() => this.handleSubmit()} className='btn--default btn--small layout--centered'>{t('common:buttons:confirm')}</button>
      </Modal>
    )
  }
}

ModalAvatar.propTypes = {
  t: func,
  isOpen: bool,
  handleClose: func
}

ModalAvatar.defaultProps = {}

export const ProfilePictureModal = translate()(ModalAvatar)



// WEBPACK FOOTER //
// ./src/components/modals/ProfilePictureModal.js